/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free countdown timer. Pick any future date and time to see a live countdown of the days, hours, minutes and seconds remaining.`)
};

const es_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de cuenta atrás gratuito. Elige cualquier fecha y hora futura para ver una cuenta atrás en vivo de los días, horas, minutos y segundos restantes.`)
};

const de_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Countdown-Timer. Wähle ein beliebiges zukünftiges Datum und eine Uhrzeit, um live zu sehen, wie viele Tage, Stunden, Minuten und Sekunden noch verbleiben.`)
};

const nl_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis aftelklok. Kies elke toekomstige datum en tijd om een live aftelling te zien van de resterende dagen, uren, minuten en seconden.`)
};

const fr_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte à rebours gratuit. Choisissez une date et une heure futures pour voir en direct le décompte des jours, heures, minutes et secondes restants.`)
};

const it_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer per il conto alla rovescia gratuito. Scegli una data e ora future per vedere in tempo reale i giorni, le ore, i minuti e i secondi rimanenti.`)
};

const pt_br2_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronômetro de contagem regressiva gratuito. Escolha qualquer data e hora futura para ver ao vivo os dias, horas, minutos e segundos restantes.`)
};

const pt_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de contagem decrescente gratuito. Escolha qualquer data e hora futuras para ver uma contagem ao vivo dos dias, horas, minutos e segundos restantes.`)
};

const ja_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のカウントダウンタイマー。任意の未来の日時を選ぶと、残りの日数・時間・分・秒がリアルタイムで表示されます。`)
};

const zh_cd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费倒计时工具。选择任意未来日期和时间，实时查看剩余的天、时、分、秒。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_meta_description", locale)
	if (locale === "en") return en_cd_meta_description(inputs)
	if (locale === "es") return es_cd_meta_description(inputs)
	if (locale === "de") return de_cd_meta_description(inputs)
	if (locale === "nl") return nl_cd_meta_description(inputs)
	if (locale === "fr") return fr_cd_meta_description(inputs)
	if (locale === "it") return it_cd_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_cd_meta_description(inputs)
	if (locale === "pt") return pt_cd_meta_description(inputs)
	if (locale === "ja") return ja_cd_meta_description(inputs)
	return zh_cd_meta_description(inputs)
};